import React from 'react';
import UploadRestriction from './UploadRestriction';

const imageSizeExceededToast = {
  level: 'warning',
  title: 'Image too large',
  hideIcon: true,
  message: <UploadRestriction />,
} as const;

export default imageSizeExceededToast;
